// Promisify reading image file.
export const readImageFile = (inputFile) => {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort();
      reject(new DOMException(`Error Processing Image File ${inputFile.name}`));
    };
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(inputFile);
  });
};
